module.exports = __webpack_public_path__ + "static/fionas-music-center-event-e97e8ea75c1be4bfdf5b2a7a35d3a6aa.jpg";